// api/inventoryAPI.js
import axiosInstance from './axiosConfig';

const inventoryAPI = {
  getAll: async (params = {}) => {
    try {
      const queryParams = {};

      if (params.populate) {
        queryParams.populate = params.populate;
      }

      if (params.includeTransactions) {
        queryParams.includeTransactions = 'true';
      }

      if (params.startDate instanceof Date) {
        queryParams.startDate = params.startDate.toISOString();
      }

      if (params.endDate instanceof Date) {
        queryParams.endDate = params.endDate.toISOString();
      }

      const response = await axiosInstance.get('/inventory', {
        params: queryParams,
      });

      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch inventory items';
    }
  },
};


export default inventoryAPI;